import React, { useContext } from "react";
import { ListContext } from "context";
import { FieldProps } from "./ListItem/Field/types";
import ListItem from "./ListItem/ListItem";
import { hasKey, isRecord } from "helpers/typing";

interface Props<TRecord> {
    recordIdField?: string;
    hasBulkActions?: boolean;
    onRowClick?: (record: TRecord, e?: React.MouseEvent) => void;
    textPlaceHolderButton?: React.ReactNode | string | null;
    onClickPlaceHolderButton?: (record: TRecord, e?: React.MouseEvent) => void;
    children: Array<React.ReactElement<FieldProps>>;
    rendererHeader: (record: TRecord) => React.ReactNode | string | null;
    grid?: number;
    has_gutter?: number;
    classContainerItem?: string;
}

const getRecordIdValue = (record: unknown, recordIdField: string): unknown => {
    if (isRecord(record) && hasKey(record, recordIdField)) {
        return record[recordIdField];
    }
    return undefined;
};

const ListItemWithIds = <TRecord,>({
    recordIdField = "id",
    hasBulkActions = false,
    onRowClick,
    textPlaceHolderButton: _textPlaceHolderButton,
    onClickPlaceHolderButton: _onClickPlaceHolderButton,
    children,
    rendererHeader,
    grid,
    has_gutter,
    classContainerItem,
}: Props<TRecord>) => {
    const { data, ...listContext } = useContext(ListContext);

    return (
        <div
            className={`search_result-container grid--row-gap-8 ${
                grid ? "grid--" + grid + (has_gutter ? " grid--has-gutter-" + has_gutter + "x" : "") : ""
            }`}
        >
            <ListItem
                data={data as TRecord[]}
                hasBulkActions={hasBulkActions}
                onSelect={(selectedData: Array<TRecord>) => {
                    listContext.setSelectedIds(selectedData.map((record) => getRecordIdValue(record, recordIdField)));
                }}
                selectedIds={listContext.selectedIds}
                onToggleItem={(record: TRecord) => {
                    const recordIdValue = getRecordIdValue(record, recordIdField);
                    if (listContext.selectedIds.includes(recordIdValue)) {
                        listContext.setSelectedIds(
                            listContext.selectedIds.filter((recordA) => recordA !== recordIdValue)
                        );
                    } else {
                        listContext.setSelectedIds([...listContext.selectedIds, recordIdValue]);
                    }
                }}
                onRowClick={onRowClick}
                isSelected={(record: TRecord) =>
                    listContext.selectedIds.includes(getRecordIdValue(record, recordIdField))
                }
                rendererHeader={rendererHeader}
                grid={grid}
                classContainerItem={classContainerItem}
            >
                {children}
            </ListItem>
        </div>
    );
};

export default ListItemWithIds;
